import React from 'react';
import ReactDOM from 'react-dom';
import { history } from '../../history/history';

//Return the Model for creating a campaign or not
const Model = ({ isShowing, hide, packageCost}) => {
return(
  isShowing? <div>
<div className="modal-overlay"></div>
    <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
      <div className="modal">
        <div className="modal-head-cross" onClick={hide}>
          <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <p className="modal-para">
          Are you sure you want to cancel the campaign ?
        </p>
        <div className="modal-footer cost_button">
         <button className="cncl" onClick={hide}>Cancel</button>
         <button className="procd" onClick={()=>{
          window.location.href='/package'
         }}>Ok</button>
        </div>
      </div>
    </div>
</div>:null
)
}

export default Model;


// WEBPACK FOOTER //
// ./web/components/campaign/model.js